import { backgroundColorMap } from './constants';
export const transformBackgroundColor = (backgroundColor) => {
    return backgroundColorMap[backgroundColor] || backgroundColor;
};
export const mapBackgroundColorToV5HeadingColorName = (color) => {
    const colorMap = {
        neutral100: 'neutral700',
        zapier: 'cream',
    };
    return colorMap[color] || 'neutral100';
};
export const mapBackgroundColorToV5TextColorName = (color) => {
    const colorMap = {
        neutral100: 'neutral800',
        zapier: 'cream',
    };
    return colorMap[color] || 'neutral100';
};
export const validateZapierBackgroundAccessibility = (backgroundColor, isSubscriptionForm, isCtaDisclaimerEnabled) => {
    const isZapierOrange = backgroundColor === 'zapier';
    if (isZapierOrange && (isSubscriptionForm || isCtaDisclaimerEnabled)) {
        console.error(`Do not use the ${isSubscriptionForm ? 'subscription form' : 'cta disclaimer'} with the zapier background. ` +
            `The disclaimer text accessibility is poor on the zapier background.`);
    }
};
export const getSupportedCTAColor = (ctaColor, backgroundColor) => {
    const supportedCTAColors = {
        neutral100: ['primary', 'primary-alt', 'brand'],
        zapier: ['primary-alt'],
        night: ['primary-dark', 'brand'],
        moss: ['primary-dark', 'brand'],
        neutral800: ['primary-dark', 'brand'],
    };
    if (supportedCTAColors[backgroundColor].includes(ctaColor)) {
        return ctaColor;
    }
    return supportedCTAColors[backgroundColor][0];
};
//# sourceMappingURL=utils.js.map
// @zapier/design-system@5.32.5 (2004a9d50)
